<!-- @format -->

<div class="reward-card hmf-display-flex hmf-mx-s hmf-mx-m-0">
	<div class="hmf-display-flex hmf-align-items-center hmf-mb-xxs">
		<img
			[ngSrc]="scoreRewardIcon"
			width="40"
			height="40"
			alt="Score reward icon"
			loading="lazy" />
		<div class="hmf-ml-xxs">
			<p class="reward-title hmf-header-bold-xs hmf-mb-0">
				All Cardholders Earn 10% Back**
				<a
					[href]="link"
					target="_blank">
					<homefield-icon
						name="alert-info-outlined"
						height="16px"
						width="16px"
						class="hmf-mr-xxs"
						fill="var(--hmf-label-secondary-subtle-static)">
					</homefield-icon>
				</a>
			</p>
			<p class="reward-details hmf-legal-xs">
				on qualified purchases at our brands for a limited time.
			</p>
		</div>
	</div>
</div>
